import { blue, cyan, green, grey, neutral, orange, pink, purple, red } from './colors';
export const themeColorsDark = {
    primary: {
        base: blue['300'],
        hover: blue['100'],
        pressed: blue['50'],
        border: blue['700'],
        alpha: blue['alpha-200'],
        surface: blue['900'],
    },
    secondary: {
        base: red['300'],
        hover: red['100'],
        pressed: red['50'],
        border: red['700'],
        alpha: red['alpha-200'],
        surface: red['900'],
    },
    background: neutral['-100-d'],
    surface: {
        primary: neutral['100-d'],
        secondary: neutral['-100-d'],
        tertiary: neutral['200-d'],
        hover: neutral['200a-d'],
        pressed: neutral['400-d'],
        disable: neutral['300-d'],
        inverse: neutral['1100-d'],
    },
    overlay: {
        primary: neutral['200-d'],
        primaryAlpha: neutral['200-d'] + '18',
        secondary: neutral['300-d'],
        hover: neutral['300a-d'],
        pressed: neutral['500-d'],
        disable: neutral['300-d'],
        inverse: neutral['1000-d'],
        still: neutral['1100-d'],
    },
    text: {
        bold: neutral['00'],
        main: neutral['1100-d'],
        subtle: neutral['800-d'],
        disable: neutral['600-d'],
        inverse: neutral['00-d'],
        link: blue['300'],
    },
    icon: {
        bold: neutral['00'],
        main: neutral['1100-d'],
        subtle: neutral['800-d'],
        disable: neutral['600-d'],
        inverse: neutral['00-d'],
        link: blue['300'],
    },
    border: {
        main: neutral['400-d'],
        bold: neutral['500-d'],
        boldest: neutral['700-d'],
    },
    alphaDarkSurface: {
        subtlest: neutral['100a-d'],
        subtle: neutral['200a-d'],
        base: neutral['300a-d'],
        bold: neutral['400a-d'],
        boldest: neutral['500a-d'],
    },
    alphaLightSurface: {
        subtlest: neutral['100a'],
        subtle: neutral['200a'],
        base: neutral['300a'],
        bold: neutral['400a'],
        boldest: neutral['500a'],
    },
    accent: {
        blue: {
            subtlest: blue['1000'],
            subtle: blue['800'],
            base: blue['400'],
            bold: blue['200'],
            boldest: blue['50'],
            alpha: blue['alpha-200'],
        },
        green: {
            subtlest: green['1000'],
            subtle: green['800'],
            base: green['400'],
            bold: green['200'],
            boldest: green['50'],
            alpha: green['alpha-200'],
        },
        orange: {
            subtlest: orange['1000'],
            subtle: orange['900'],
            base: orange['600'],
            bold: orange['200'],
            boldest: orange['50'],
            alpha: orange['alpha-200'],
        },
        red: {
            subtlest: red['1000'],
            subtle: red['800'],
            base: red['400'],
            bold: red['200'],
            boldest: red['50'],
            alpha: red['alpha-200'],
        },
        grey: {
            subtlest: neutral['200-d'],
            subtle: neutral['400-d'],
            base: neutral['600-d'],
            bold: neutral['800-d'],
            boldest: neutral['1000-d'],
            alpha: neutral['300a-d'],
        },
        pink: {
            subtlest: pink['1000'],
            subtle: pink['700'],
            base: pink['400'],
            bold: pink['200'],
            boldest: pink['50'],
            alpha: pink['alpha-200'],
        },
        purple: {
            subtlest: purple['1000'],
            subtle: purple['600'],
            base: purple['400'],
            bold: purple['200'],
            boldest: purple['50'],
            alpha: purple['alpha-200'],
        },
        cyan: {
            subtlest: cyan['1000'],
            subtle: cyan['800'],
            base: cyan['400'],
            bold: cyan['200'],
            boldest: cyan['50'],
            alpha: cyan['alpha-200'],
        },
    },
    decorative: {
        white: neutral['00'],
        grey: grey['00'],
        black: neutral['00-d'],
        pink: pink['500'],
        red: red['700'],
        orange: orange['800'],
        green: green['800'],
        blue: blue['800'],
        purple: purple['700'],
        cyan: cyan['800'],
    },
};
